"use strict";

Object.defineProperty(exports, "__esModule", {
    value: true
});
var checkIfError = exports.checkIfError = function checkIfError(input, meta) {
    return meta && (meta.touched || meta.visited && input.value.length > 0) && meta.error && !meta.active;
};

var checkIfSuccess = exports.checkIfSuccess = function checkIfSuccess(input, meta) {
    return meta && (meta.touched || meta.visited && input.value.length > 0) && !meta.error;
};
//# sourceMappingURL=utils.js.map


//////////////////
// WEBPACK FOOTER
// ./~/@wh/login-component/dist/main/input-group/utils.js
// module id = 481
// module chunks = 0